import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_764s5p6h4a: FaireBrandEntity = {
  token: "b_764s5p6h4a",
  type: "brand",
  name: "Chili Beak",
  avatarUrl:
    "https://cdn.faire.com/fastly/da4dccd628dca41556c7df4b2df24d04913642122f5dc48ea1301988bf54e198.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/158b3fb85acb913c0a1e9f7b8e15c2559d8b3da255529c0b2a607200af357c8a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/da4dccd628dca41556c7df4b2df24d04913642122f5dc48ea1301988bf54e198.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/158b3fb85acb913c0a1e9f7b8e15c2559d8b3da255529c0b2a607200af357c8a.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 200,
  rating: 4,
  reviewCount: 1,
  isInsider: true,
  description:
    "Our story begins many years ago in the land of authentic spice, seasoning, and salsa—Mexico! We discovered a local chili oil that was full of flavor, packed a punch, and tasted good on just about everything. Giselle, who had grown up in Guadalajara, introduced Jason to a new way of approaching meals: one that was communal, filled with heart, and topped with unique oils and salsas.\n\nAfter moving from Texas to Salt Lake City, the couple couldn’t find a chili oil similar to the one they’d enjoyed in Mexico. So, they created their own. For their first four years of business, Chili Beak handcrafted oil was sold at neighborhood stores and farmer’s markets, quickly gaining a buzzing reputation across Salt Lake City.\n\nRealizing that they wanted to take a break from business to focus on their family, the couple connected with David “Max” Born, a highly-regarded food industry figure and an innovative CEO, consultant, and creative entrepreneur. With over a decade of experience in food manufacturing, food safety, and marketing, Max was the VP of Quality and Innovation for Sevillo Fine Foods. But, more importantly, he had a growth-driven mindset, community focus, and the hands-on expertise to grow Chili Beak beyond farmer’s market stalls and introduce it to restaurants and retailers across the country.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:47.836Z",
    importedBy: "entity-db-cli",
  },
};
